'use strict';

const { bindGA } = require('./util/analytics-util');
const { queryAll, queryFirst } = require('lilly/domUtil');

const STORE_SELECTIONS = 'store selections';
const { GET_DIRECTIONS, STORE_INTERACTION } = require('./util/constants');

/**
 * Analytics for Store Details Pages
 */
function initEvents() {
    const container = queryFirst('.store-events-container');
    const storeName = queryFirst('.page-title', container)?.textContent.trim();

    // Store Events
    bindGA(queryAll('.store-event a', container), {
        event_category: STORE_SELECTIONS,
        event_action: 'events',
        event_label: storeName
    });

    // Set Preferred Store
    bindGA(queryAll('.set-preferred-store a', container), (bindElement, srcElement) => ({
        event_category: STORE_SELECTIONS,
        event_action: 'set preferred store',
        event_label: [storeName, srcElement.dataset.storeId]
    }));

    // Get Directions
    bindGA(queryAll('.get-directions-btn', container), {
        // GA4
        event_name: STORE_INTERACTION,
        interaction_type: GET_DIRECTIONS,
        // GA360
        event_category: STORE_SELECTIONS,
        event_action: GET_DIRECTIONS,
        event_label: storeName
    });
}

initEvents();
